import PropTypes from 'prop-types';

import { CardContainer, Icon, IconWrapper, Label, Value } from './MetricCard.styles';

const MetricCard = ({
  icon,
  iconAlt,
  value,
  label,
  onClick,
  backgroundColor = 'white',
  color,
}) => {
  return (
    <CardContainer onClick={onClick} backgroundColor={backgroundColor}>
      <IconWrapper $color={color}>
        <Icon src={icon} alt={iconAlt} />
      </IconWrapper>
      <Label>{label}</Label>
      <Value $color={color}>{value}</Value>
    </CardContainer>
  );
};

MetricCard.propTypes = {
  icon: PropTypes.string.isRequired,
  iconAlt: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  backgroundColor: PropTypes.string,
};

export default MetricCard;
